<div fxLayout="column">
  <app-page-header [section]="'Users and Access'"
                   [title]="'Grant your users access and permissions'"
                   [description]="'This is your settings page where you can add different roles and set permissions for \n'+
'your team members specific to your business operations.'"
                   [isTabbed]="true"
                   [tabs]="tabs"
                   (tabsChangeEvent)="changeTabs($event)"
                   [selectedTab]="getInitialTab()">
  </app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">

    @switch (activeTab){

      @case ('rbac-roles'){
        <app-grants-roles [selectedOfferingUuid]="offeringId"></app-grants-roles>
      }
      @default {
        <app-grants-role-groups [selectedOfferingUuid]="offeringId"></app-grants-role-groups>
      }

    }


  </div>

</div>
